import { select, Store } from '@ngrx/store';
import { debounceTime } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { AppState } from '../../../../core/reducers';
import { BaseDataSource, QueryResultsModel } from '../../../../core/_base/crud';
import { Form } from '../models';
import {
  selectFormPage,
  selectFormPageLoading,
  selectFormShowInitWaitingMessage,
} from '../selectors';

export class FormDataSource extends BaseDataSource {
  private _forms: Form[];

  constructor(private store: Store<AppState>, private paginator: MatPaginator) {
    super();

    this.loading$ = this.store.select(selectFormPageLoading);
    this.isPreloadTextViewed$ = this.store.select(selectFormShowInitWaitingMessage);
    this.store
      .pipe(select(selectFormPage), debounceTime(500))
      .subscribe((res: QueryResultsModel) => {
        this._forms = res.items;
        this.entitySubject.next(res.items.slice(0, this.paginator.pageSize));
        this.paginatorTotalSubject.next(res.totalCount);
      });
  }

  get forms() {
    return this._forms;
  }
}
